import(/* webpackMode: "eager" */ "/hisea-ssr/src/app/(app)/claim-warranty/loading.js");
